import Tooltip from 'rc-tooltip';
import * as React from 'react';

import { Link } from 'react-router-dom';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import {  getHotelSlug, makeid, TRIPADVISOR  , ModalWrapper } from '../core/index';
import { HotelBedData } from '../shared/index';
import { getHotelDetail, isNull } from '../utils/index';
export interface MyHotelBookingDataProps extends BaseComponentProps {
    lang: string;
    hotel: HotelBedData.Hotel;
    id: number | any;
    cal: any;
}

export interface MyHotelBookingDataState extends BaseComponentState {
    hotelData: HotelBedData.Hotel;
    request: boolean;
    tripmodelOpen: boolean;
}

export class MyHotelBookingData extends BaseComponent<MyHotelBookingDataProps, MyHotelBookingDataState> {

    constructor(props: MyHotelBookingDataProps) {
        super(props);
        this.state = {
            hotelData: props.hotel,
            request: true,
            tripmodelOpen: false,
        };
    }

    componentWillMount() {
        this.getData();
    }

    componentDidUpdate(prevProps: MyHotelBookingDataProps, prevState: MyHotelBookingDataState) {
        if (prevProps.id !== this.props.id) {
            this.getData();
        }
    }

    getData: () => any = () => {
        getHotelDetail(this.props.hotel.code!, this.props.lang).then(
            (data: any) => {
                this.setStateHelper(st => {
                    st.hotelData.image = data.image;
                    st.hotelData.images = data.images;
                    st.hotelData.facilities = data.facilities;
                    st.hotelData.img_thumb = data.img_thumb;
                    st.hotelData.TripAdvisorData = data.TripAdvisorData;
                    st.request = false;
                });
            }
        ).catch(exc => {
            console.log(exc);
        });
    }

    tripModelClosDialog: () => any = () => {
        this.setState({ tripmodelOpen: false });
    }

    render() {
        if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
        let ret = <span />;
        let style: ReactModal.Styles = {
            overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0, 0.75)', zIndex: 9999 },
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                overflow: 'hidden',
                backgroundColor: 'rgba(0,0,0,0)',
                border: 0
            }
        };
        if (this.state.request === false) {
            let hotelData = this.state.hotelData;
            let tripadvisor = <span />;

            if (!isNull(hotelData.TripAdvisorData)) {
                let rangked = '';
                if (!isNull(hotelData.TripAdvisorData.ranking_data) && !isNull(hotelData.TripAdvisorData.ranking_data.ranking_string)) {
                    rangked = hotelData.TripAdvisorData.ranking_data.ranking_string;
                }
                let isiToolTip = [];
                if (!isNull(hotelData.TripAdvisorData) && !isNull(hotelData.TripAdvisorData.subratings) && hotelData.TripAdvisorData.subratings.length > 0) {
                    for (let subrating of hotelData.TripAdvisorData.subratings) {
                        isiToolTip.push(
                            <p key={makeid()} >{subrating.localized_name} :  <img src={subrating.rating_image_url} /> </p>
                        );
                    }
                }
                tripadvisor = (
                    <div>
                        <p>
                            <Tooltip
                                placement='bottom'
                                overlay={<div style={{ minHeight: 50, minWidth: 50 }}> {isiToolTip} </div>}
                            >
                                <a
                                    onClick={
                                        () => {
                                            this.setState({ tripmodelOpen: true });
                                        }
                                    }
                                >
                                    TripAdvisor Traveller Rating<br />
                                    <img src={hotelData.TripAdvisorData.rating_image_url} style={{ width: 100 }} /> <span style={{ fontSize: 10 }}>Base on {hotelData.TripAdvisorData.num_reviews} reviews </span>
                                </a>
                            </Tooltip>
                        </p>
                        <p>
                            <span className="btn-purple" style={{ padding: '2px 5px' }}>
                                Ranked : {rangked}
                            </span>
                        </p>
                    </div>
                );

            }
            let hotelSlug = getHotelSlug(hotelData.name!, hotelData.code!);
            ret = (
                <div className="row">
                    <div className="col-md-4">
                        <img src={`https://photos.hotelbeds.com/giata/${hotelData.image}`} style={{ width: 160 }} />
                    </div>
                    <div className="col-md-8">
                        <Link to={`/${hotelSlug}`} target="_blank" >
                            <h5>{hotelData.name} 
                            </h5> 
                        </Link>
                        {tripadvisor}
                        {this.props.cal}
                    </div>
                    <ModalWrapper
                        style={style}
                        isOpen={this.state.tripmodelOpen}
                        onRequestClose={this.tripModelClosDialog}
                        role="dialog"
                        contentLabel="Minimal Modal Example"
                    >
                        <div style={{ maxWidth: 800, maxHeight: '80vh' }}>
                            <iframe style={{ width: '100vh', height: '100vh' }} src={`${TRIPADVISOR.WidgetEmbed}${this.props.id}`} />
                        </div>
                    </ModalWrapper>
                </div>
            );

        }
        return (
            [ret]

        );
    }
}



// WEBPACK FOOTER //
// ./src/my-account/MyHotelBookingData.tsx